










import Vue from 'vue';
import Hero from '@/components/Hero.vue';
import Explanation from '@/components/Explanation.vue';
import WhyFlexbox from '@/components/WhyFlexbox.vue';

export default Vue.extend({
  layout: 'navLayout',

  components: {
    Hero,
    Explanation,
    WhyFlexbox,
  },
});
